import type { DeclaratieStatus } from '@kennisbank/shared';

/** Eén plek voor enum → Nederlands label + chip-styling, zoals bij incidenten. */
export const STATUS_LABEL: Record<DeclaratieStatus, string> = {
  ingediend: 'Ingediend',
  akkoord: 'Akkoord',
  afgewezen: 'Afgewezen',
  verstuurd: 'Verstuurd',
};

export const STATUS_CHIP: Record<DeclaratieStatus, string> = {
  ingediend: 'bg-petrol-50 text-petrol-700',
  akkoord: 'bg-mosterdgeel-10 text-ring1-fg',
  afgewezen: 'bg-red-50 text-red-700',
  verstuurd: 'bg-ink-50 text-ink-900/60',
};

/** Centen → "€ 12,50" met Nederlandse notatie. */
export function euro(cent: number): string {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cent / 100);
}

export function formatDatum(iso: string): string {
  return new Date(iso).toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
